import { Trans } from '@lingui/macro'
import { StartOutlined } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import { ButtonIcon } from 'app/views/common-components/ButtonIcon'
import { useFormContext } from 'app/views/forms/form-page/FormContext'
import { PrequalificationFundBanner, prequalificationStageToMessages } from 'app/views/grants/applications/old-application/PrequalificationFundBanner'
import { useSnackbar } from 'notistack'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ACTION_BUTTON_ACTIONS } from './FormEditorActionButton'

export const FormActionButton = ({
  title,
  typeProps,
  preview,
  ...props
}) => {
  const fundingStreams = useSelector(state => state.fundingStreams.streams)
  const { variant, color, action, parameter } = typeProps
  const { actionHandlers, activePrequalificationsMap } = useFormContext()
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()

  let disabled = false
  let cancelDefaultAction = false
  let label = title
  const fundingStreamInfo = parameter && fundingStreams.find(fs => fs.id === parameter)

  const isPrequalification = fundingStreamInfo && fundingStreamInfo.prequalificationEligibilityQuiz
  let existingPrequalifications = []
  if (activePrequalificationsMap) {
    existingPrequalifications = activePrequalificationsMap[parameter] || []
  }
  const prequalificationData = isPrequalification && existingPrequalifications[0]


  if (prequalificationData) {
    disabled = !prequalificationStageToMessages[prequalificationData.stage].redirect && !prequalificationStageToMessages[prequalificationData.stage].canStart
    label = prequalificationStageToMessages[prequalificationData.stage].button
    cancelDefaultAction = prequalificationStageToMessages[prequalificationData.stage].redirect
  } else if (isPrequalification) {
    label = <Trans>START_PREQUALIFICATION</Trans>
  }

  return (
    <div>
      <Button
        fullWidth
        disabled={disabled || props.disabled}
        color={color ?? 'primary'}
        variant={variant ?? 'contained'}
        onClick={e => {
          if (action) {
            if (preview) {
              enqueueSnackbar(`This will call ${ACTION_BUTTON_ACTIONS[action].label} with parameter ${parameter}`, { variant: 'info' })
            } else if (action in actionHandlers) {
              if (cancelDefaultAction) {
                history.push(
                  '/grants/prequalification/' + prequalificationData.id
                )
              } else {
                actionHandlers[action](parameter)
              }
            }
          }
        }}
      >
        <Typography>
          {label}
        </Typography>
        <ButtonIcon IconClass={StartOutlined} />
      </Button>
      {prequalificationData && (
        <Box sx={{ marginTop: '8px' }}>
          <PrequalificationFundBanner currentStage={prequalificationData.stage} />
        </Box>
      )}
    </div>
  )
}
